import $ from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap/tooltip';


$(document).ready(function () {
    $('[data-toggle="tooltip"]:not(.funding-tooltip)').tooltip();
    $('.funding-tooltip[data-toggle="tooltip"]').tooltip({
        html: true,
        sanitize: false,
        trigger: 'focus hover',
        container: 'body',
        template: '<div class="tooltip funding-tooltip-container" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    });
});
